<template>
  <div
    class="modal__cover text-modal-without-primary"
    @click.self="onClickModalCover"
  >
    <div class="modal__content">
      <div class="modal__descriptions">
        <div class="modal__text">
          <div class="modal__text__title">
            <span>{{ titleText }}</span>
          </div>
          <div class="modal__text__caption">
            <slot />
          </div>
        </div>
        <div class="modal__btn">
          <div class="modal__btn--cancel">
            <span @click="onClickCancelButton">{{ cancelButtonText }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleText: {
      type: String,
      required: true
    },
    cancelButtonText: {
      type: String,
      required: true
    }
  },
  methods: {
    onClickModalCover() {
      this.$emit('clicked-modal-cover')
    },
    onClickCancelButton() {
      this.$emit('clicked-cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
.text-modal-without-primary {
  .modal {
    &__text__title {
      white-space: pre-wrap;
      margin-bottom: 0;
    }

    &__btn--cancel {
      padding-top: 0;
    }
  }
}
</style>
